// extracted by mini-css-extract-plugin
export default {"container":"App_container__8SCWu","index":"App_index__3C0h0","text":"App_text__pD84p","dividerD":"App_dividerD__n-UGA","dividerM":"App_dividerM__VClI4","btn":"App_btn__oZEv4"};